module.exports = __webpack_public_path__ + "assets/img/11_664_big.de4e2c8f.jpg";